module.exports = __webpack_public_path__ + "static/media/16UNODC7.71cdcb24.jpg";